import { Pipe, PipeTransform } from '@angular/core';

@Pipe({
    name: 'filesize',
    standalone: false
})
export class FileSizePipe implements PipeTransform {
    transform(size: number, extension = 'MB') {
        return (size / (1024 * 1024)).toFixed(2) + extension;
    }
}
